import fetchLoyaltyAccount from 'actions/loyalty/fetchLoyaltyAccount'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect } from 'react'

function useLoyaltyAccount() {
  const dispatch = useAppDispatch()
  const loyaltyAccount = useAppSelector(state => state.loyalty.account)

  useEffect(() => {
    dispatch(fetchLoyaltyAccount())
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return loyaltyAccount
}

export default useLoyaltyAccount
